import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { isUndefined } from '../../predicates/type';
import { TagProps } from './types';
import { CloseTiny } from '../Icons/CloseTiny';

export const Tag: FC<React.PropsWithChildren<TagProps>> = ({
	className,
	children,
	onClick,
	id,
	removable,
	disabled,
	dataTestId = 'tag',
}) => {
	const hasActiveState = !isUndefined(onClick);
	const componentClasses = classNames(className, classes.tag, {
		[classes.tag_active]: hasActiveState,
		[classes.tag_disabled]: disabled,
	});
	const handleClick = useCallback(() => {
		if (disabled || isUndefined(onClick)) {
			return;
		}

		onClick(id);
	}, [disabled, onClick, id]);

	return (
		<button
			type='button'
			className={componentClasses}
			onClick={handleClick}
			data-testid={dataTestId}
		>
			{children}
			{removable && <CloseTiny className={classes.icon} />}
		</button>
	);
};
